/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AuthorizationStatusResponse interface.
 */
export function instanceOfAuthorizationStatusResponse(value) {
    return true;
}
export function AuthorizationStatusResponseFromJSON(json) {
    return AuthorizationStatusResponseFromJSONTyped(json, false);
}
export function AuthorizationStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isAuthorized': json['isAuthorized'] == null ? undefined : json['isAuthorized'],
        'region': json['region'] == null ? undefined : json['region'],
        'appIds': json['appIds'] == null ? undefined : json['appIds'],
    };
}
export function AuthorizationStatusResponseToJSON(json) {
    return AuthorizationStatusResponseToJSONTyped(json, false);
}
export function AuthorizationStatusResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'isAuthorized': value['isAuthorized'],
        'region': value['region'],
        'appIds': value['appIds'],
    };
}
